<template>
    <div class="all-section-area">
        <MainHeader />
        <main class="main-content-wrap">
            <PageTitle mainTitle="Treeview" pageTitle="Treeview" />
            <TreeviewContent />
            <div class="flex-grow-1"></div>
            <FooterArea />
        </main>
    </div>
</template>

<script>
import MainHeader from '../Layouts/MainHeader'
import PageTitle from '../Common/PageTitle'
import TreeviewContent from '../Treeview/TreeviewContent'
import FooterArea from '../Layouts/FooterArea'

export default {
    name: 'TreeviewPage',
    components: {
        MainHeader,
        PageTitle,
        TreeviewContent,
        FooterArea,
    },
    mounted () {
        document.body.classList.add('body-bg-f8faff')
    },
}
</script>